import React from 'react'
import { SvgIcon } from './SvgIcon'

interface Props {
  className?: string
}

export function Copy({ className }: Props) {
  return (
    <SvgIcon className={className} viewBox="0 0 50 50" fill="currentColor">
      <path d="M46.43,14.29H17.86a3.56,3.56,0,0,0-3.57,3.57V46.43A3.57,3.57,0,0,0,17.86,50H46.43A3.57,3.57,0,0,0,50,46.43V17.86A3.57,3.57,0,0,0,46.43,14.29ZM17.86,46.43V17.86H46.43V46.43Z" />
      <path d="M8.93,32.14H3.57V3.57H32.14V8.93a1.79,1.79,0,0,0,3.57,0V3.57A3.57,3.57,0,0,0,32.14,0H3.57A3.57,3.57,0,0,0,0,3.57V32.14a3.57,3.57,0,0,0,3.57,3.57H8.93a1.79,1.79,0,0,0,0-3.57Z" />
    </SvgIcon>
  )
}
